import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import { config } from '../../config';
import { getUserProfile, type UserProfile } from '../../configuration/login/loginSlice';
import type { State } from '../../reducers';
import { positionSharingActions } from '../positionSharingDialog/redux/positionSharing.redux';
import Header from './Header';

export interface HeaderPropertiesFromDispatch {
    showPositionSharingDialog: () => void;
}

export interface HeaderPropertiesFromState {
    homeRoute: string;
    userProfile: UserProfile | null;
}

const mapDispatchToProps = (dispatch: Dispatch): HeaderPropertiesFromDispatch => ({
    showPositionSharingDialog: () => dispatch(positionSharingActions.setShowPositionSharingDialog(true)),
});

const mapStateToProps = (state: State): HeaderPropertiesFromState => ({
    homeRoute: config.homeRoute as string,
    userProfile: getUserProfile(state),
});

const HeaderContainer = connect(mapStateToProps, mapDispatchToProps)(Header);

export default HeaderContainer;
